const Colors = {
  White: "#FFFFFF",
  DarkLicorice: "#141415",
  WhiteGray: "#C4C4C6",
  Blue: "#2F54EB",
  LightPink: "#FFB6C1",
  Tomato: "#FF6347",
  ForestGreen: "#228B22",
  TealBlue: "#12b2b3",
  TiffanyBlue: "#12B2B3",
  TiffanyBlueOpacity: "rgba(18, 178, 179, 0.4)",
  TealBlue20: "#12b2b320",
  TurquoiseBlue: "#56E0E0",
  Snow: "#FAFAFA",
  Isabelline: "#F0F0F0",
  GrayBlue: "#9393AA",
  BlueCrayola: "#2574FF",
  Platinum: "#E0E0E0",
  DarkJungleGreen: "#1E1F20",
  DarkJungleGreenOpacity: "rgba(30, 31, 32, 0.2)",
  ModalBackground: "#1E1F2068",
  Malachite: "#00D65B",
  DarkNavy: "#020433",
  MediumTurquoise: "#53D0EC",
  DodgerBlue: "#1DA1F2",
  Jade: "#0EAD69",
  OysterBay: "#D9F3F3",
  PinkOrange: "#FE9870",
  WhiteSmoke: "#F6F6F6",

  //Red:
  RedNeonFuchsia: "#FA4169",
  Red: "red",

  //Black:
  Black: "#000000",
  Black68: "#00000068",
  Black34: "#00000034",

  //Orange:
  Orange: "#FE9870",

  //Blue
  bDazzledBlue: "#3B5998",

  //Info
  Info: "#FFC107",

  //Shadow
  boxShadow: "rgba(0, 64, 128, 0.04)",
  //BottomSheet
  BottomSheetColor: "#1d1f1f",
  //White
  White20: "#FFFFFF20",
  WhiteOpacity: "rgba(255,255,255,0.3)",
  LineWhite: "rgba(246, 246, 246, 1)",
  RaisinBlack: "rgba(33, 33, 34, 1)",
  InnearColor: "#313133",
  DarkShadow: "#1B1B1C",
  ChatBox: "rgba(33, 33, 34, 0.68)",
  LightChatBox: "rgba(240, 240, 240, 0.68)",
  GreenTag: '#268787',
  BlueTag: '#0E5DCB',
  LightWhite: '#F9F9FB'
};

export default Colors;
